export const validateOptionalRequireIf = (
  value: string,
  fieldName: string,
  getValues: () => Record<string, any>,
): boolean => {
  const getFieldValue = (fieldName: string) => {
    return getValues()[fieldName];
  };
  const fieldValue = getFieldValue(fieldName);
  const isFieldEmpty = !fieldValue || (Array.isArray(fieldValue) && fieldValue.length === 0);
  const isValueEmpty = !value || (Array.isArray(value) && value.length === 0);
  return !isValueEmpty || !isFieldEmpty;
};

export const validateErrorIfSetWith = (
  value: string,
  fieldName: string,
  getValues: () => Record<string, any>,
): boolean => {
  const getFieldValue = (fieldName: string) => {
    return getValues()[fieldName];
  };
  const fieldValue = getFieldValue(fieldName);
  const isFieldEmpty = !fieldValue || (Array.isArray(fieldValue) && fieldValue.length === 0);
  const isValueEmpty = !value || (Array.isArray(value) && value.length === 0);
  if (isFieldEmpty || (!isFieldEmpty && isValueEmpty)) {
    return true;
  }
  return false;
};
